export const downloadCSV = (csv: string, filename: string): void => {
    const fakeLink = document.createElement("a");
    fakeLink.style.display = "none";
    document.body.appendChild(fakeLink);
    // UTF-8 BOM ensures Excel opens the file with correct encoding
    const blob = new Blob(["﻿" + csv.replace(/’/g, "’")], { type: "text/csv;charset=utf-8" });
    fakeLink.setAttribute("href", URL.createObjectURL(blob));
    fakeLink.setAttribute("download", `${filename}.csv`);
    fakeLink.click();
    document.body.removeChild(fakeLink);
};
